// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'linkedin';

export const Component = () => (
  <path
    fill='currentColor'
    d='M4.306 2.41c0 .448-.172.862-.518 1.207-.379.31-.793.482-1.31.482s-.965-.172-1.275-.482A1.664 1.664 0 0 1 .72 2.41c0-.518.172-.931.483-1.242.31-.31.724-.448 1.31-.448.551 0 .965.138 1.275.448.31.345.483.76.518 1.242zm-.104 13.93H.822V5.445h3.38zm2-7.413c0-1.449-.034-2.62-.068-3.483h2.93l.173 1.517h.069c.724-1.172 1.828-1.758 3.38-1.758 1.172 0 2.103.379 2.827 1.172.725.793 1.069 1.965 1.069 3.517v6.449h-3.38v-6.035c0-1.552-.586-2.345-1.724-2.345-.827 0-1.413.414-1.724 1.242-.069.172-.103.448-.103.862v6.276H6.203z'
  />
);

export const viewBox = '0 0 18 18';
